import { UpgradeConfigKey, UpgradeType } from '../types/game-types';
import type { TreeNodeData } from 'skill-tree/src/models';

export const upgradesConfig: Partial<Record<UpgradeConfigKey, TreeNodeData[]>> = {
  // @ts-ignore
  BUG_HIDE: [],
  // bird: [],
  click: [
    {
      id: UpgradeType.CarpalCure,
      children: [UpgradeType.IronFinger, UpgradeType.PerfectClick],
      subTreeConfig: { overridePlacement: [7, 6], unlockAt: 1 },
    },
    {
      id: UpgradeType.IronFinger,
      children: [UpgradeType.FeatherFinger],
      subTreeConfig: { unlockAt: 3 },
    },
    {
      id: UpgradeType.FeatherFinger,
      children: [UpgradeType.MoneyCursor],
      nodeConfig: {
        lengthMultiplier: 2.2,
      },
      subTreeConfig: {
        direction: 4,
        unlockAt: 3,
      },
    },
    {
      id: UpgradeType.MoneyCursor,
      children: [UpgradeType.GoldenExplosion],
      subTreeConfig: {
        direction: 2,
        unlockAt: 3,
      },
      nodeConfig: {
        lengthMultiplier: 3.2,
      },
    },
    {
      id: UpgradeType.PerfectClick,
      children: [UpgradeType.CriticalStrike],
      subTreeConfig: { direction: 3, unlockAt: 3 },
    },
    {
      id: UpgradeType.CriticalStrike,
      children: [UpgradeType.WakeupCall],
      subTreeConfig: { direction: 6, unlockAt: 3 },
      nodeConfig: {
        lengthMultiplier: 1.2,
      },
    },
    {
      id: UpgradeType.WakeupCall,
      children: [],
      subTreeConfig: {},
    },
    {
      id: UpgradeType.GoldenExplosion,
      children: [UpgradeType.NaturalLeader],
      subTreeConfig: { direction: 3, unlockAt: 3 },
    },
    {
      id: UpgradeType.NaturalLeader,
      children: [],
      nodeConfig: {
        lengthMultiplier: 0.7,
      },
    },
  ],
  warrior: [
    {
      id: UpgradeType.ShortSword,
      children: [UpgradeType.LongSword, UpgradeType.Barbarian, UpgradeType.SilverBlade],
      subTreeConfig: { overridePlacement: [7, 1, 3], unlockAt: 3 },
    },
    {
      id: UpgradeType.LongSword,
      children: [UpgradeType.ThickArmor],
      subTreeConfig: { direction: 4 },
    },
    // {
    //   id: UpgradeType.TwoHandedSword,
    //   children: [UpgradeType.ThickArmor],
    //   subTreeConfig: {
    //     direction: 3,
    //     unlockAt: 1000,
    //   },
    // },
    {
      id: UpgradeType.SilverBlade,
      children: [UpgradeType.GoldenBlade],
    },
    {
      id: UpgradeType.GoldenBlade,
      children: [UpgradeType.LoyalMercenaries],
      subTreeConfig: {
        direction: 6,
      },
    },
    {
      id: UpgradeType.Barbarian,
      children: [UpgradeType.BattleShout],
      subTreeConfig: {
        direction: 2,
      },
      nodeConfig: { lengthMultiplier: 2.5 },
    },
    {
      id: UpgradeType.BattleShout,
      children: [UpgradeType.WarCry],
      subTreeConfig: {
        direction: 5,
      },
      nodeConfig: {
        lengthMultiplier: 2,
      },
    },
    {
      id: UpgradeType.WarCry,
      children: [],
      nodeConfig: {
        lengthMultiplier: 2.7,
      },
    },
    {
      id: UpgradeType.LoyalMercenaries,
      children: [UpgradeType.TeamWork],
      subTreeConfig: {
        direction: 5,
      },
      nodeConfig: { lengthMultiplier: 2.2 },
    },
    {
      id: UpgradeType.LoyalServants,
      children: [UpgradeType.TeamWork],
      nodeConfig: {
        lengthMultiplier: 1.15,
      },
      subTreeConfig: {
        direction: 5,
      },
    },
    {
      id: UpgradeType.TeamWork,
      children: [],
    },
    // {
    //   id: UpgradeType.CriticalChance,
    //   children: [UpgradeType.CriticalDamage],
    //   nodeConfig: {
    //     lengthMultiplier: 2,
    //   },
    // },
    // {
    //   id: UpgradeType.CriticalDamage,
    //   children: [UpgradeType.Barbarian],
    //   subTreeConfig: {
    //     direction: 2,
    //   },
    // },

    {
      id: UpgradeType.ThickArmor,
      children: [UpgradeType.FireArmor],
      nodeConfig: {
        lengthMultiplier: 2.2,
      },
      subTreeConfig: {
        direction: 5,
      },
    },
    {
      id: UpgradeType.FireArmor,
      children: [],
      subTreeConfig: {},
    },
  ],
  wizard: [
    {
      id: UpgradeType.ManaSurge,
      children: [UpgradeType.MagicMouse, UpgradeType.SilverStaff, UpgradeType.ManaPool, UpgradeType.ManaBoost],
      subTreeConfig: { overridePlacement: [7, 0, 1, 4], unlockAt: 1 },
    },
    {
      id: UpgradeType.MagicMouse,
      children: [],
      nodeConfig: { lengthMultiplier: 0.8 },
    },
    {
      id: UpgradeType.ManaPool,
      children: [],
      subTreeConfig: {},
      nodeConfig: { lengthMultiplier: 0.8 },
    },
    {
      id: UpgradeType.ManaBoost,
      children: [UpgradeType.MagicMissile],
      nodeConfig: { lengthMultiplier: 0.8 },
    },
    {
      id: UpgradeType.MagicMissile,
      children: [UpgradeType.ManaSword],
    },
    {
      id: UpgradeType.ManaSword,
      children: [],
      nodeConfig: { lengthMultiplier: 2 },
    },
    {
      id: UpgradeType.SilverStaff,
      children: [UpgradeType.GoldenStaff],
      subTreeConfig: { direction: 7 },
      nodeConfig: { lengthMultiplier: 2 },
    },
    {
      id: UpgradeType.GoldenStaff,
      children: [UpgradeType.Archimage],
      subTreeConfig: { direction: 1 },
    },
    {
      id: UpgradeType.Archimage,
      children: [UpgradeType.WeatherForecast],
      subTreeConfig: { direction: 3 },
    },
    {
      id: UpgradeType.WeatherForecast,
      children: [UpgradeType.LightningStrike],
      subTreeConfig: { direction: 6 },
    },
    {
      id: UpgradeType.LightningStrike,
      children: [],
      nodeConfig: { hideLink: true },
    },
  ],
  elf: [
    {
      id: UpgradeType.MultipleShot,
      children: [UpgradeType.HuntersEye, UpgradeType.CriticalChance, UpgradeType.SilverArrow, UpgradeType.IceArrow],
      subTreeConfig: {
        direction: 2,
        unlockAt: 1,
        overridePlacement: [6, 0, 4, 2],
      },
    },
    {
      id: UpgradeType.HuntersEye,
      children: [UpgradeType.HuntingSeason],
      subTreeConfig: {
        unlockAt: 3,
      },
      nodeConfig: {
        lengthMultiplier: 2,
      },
    },
    {
      id: UpgradeType.HuntingSeason,
      children: [],
      subTreeConfig: { direction: 2 },
    },
    {
      id: UpgradeType.CriticalChance,
      children: [UpgradeType.CriticalDamage],
      subTreeConfig: {
        direction: 7,
      },
      nodeConfig: { lengthMultiplier: 1.7 },
    },
    {
      id: UpgradeType.CriticalDamage,
      children: [],
    },
    {
      id: UpgradeType.SilverArrow,
      children: [UpgradeType.GoldenArrow],
      nodeConfig: { lengthMultiplier: 1.7 },
      subTreeConfig: { direction: 5 },
    },
    {
      id: UpgradeType.GoldenArrow,
      children: [],
    },
    {
      id: UpgradeType.IceArrow,
      children: [],
      subTreeConfig: {},
    },
  ],
  thief: [
    {
      id: UpgradeType.FastHands,
      children: [UpgradeType.SharpDagger, UpgradeType.Pickpocket],
      subTreeConfig: { overridePlacement: [7, 3], unlockAt: 2 },
    },
    {
      id: UpgradeType.SharpDagger,
      children: [UpgradeType.PoisonDagger],
      subTreeConfig: { direction: 1 },
    },
    {
      id: UpgradeType.PoisonDagger,
      children: [UpgradeType.BlackMamba, UpgradeType.LingeringToxin],
      subTreeConfig: { overridePlacement: [1, 3] },
      nodeConfig: { lengthMultiplier: 1.7 },
    },
    {
      id: UpgradeType.BlackMamba,
      children: [],
      nodeConfig: { lengthMultiplier: 0.85 },
    },
    {
      id: UpgradeType.LingeringToxin,
      children: [],
      nodeConfig: { lengthMultiplier: 0.85 },
    },
    {
      id: UpgradeType.Pickpocket,
      children: [UpgradeType.MidasTouch],
      subTreeConfig: { direction: 5 },
    },
    {
      id: UpgradeType.MidasTouch,
      children: [UpgradeType.SmokeBomb],
      subTreeConfig: { direction: 7 },
      nodeConfig: { lengthMultiplier: 1.2 },
    },
    {
      id: UpgradeType.SmokeBomb,
      children: [],
      subTreeConfig: {},
    },
  ],
  bard: [
    {
      id: UpgradeType.TuningFork,
      children: [UpgradeType.Encore, UpgradeType.LockerRoomSpeech],
      subTreeConfig: { overridePlacement: [0, 6] },
    },
    {
      id: UpgradeType.LuteSolo,
      children: [],
      subTreeConfig: {},
      nodeConfig: { lengthMultiplier: 1.5 },
    },
    {
      id: UpgradeType.ObnoxiousGuitarist,
      children: [UpgradeType.LuteSolo, UpgradeType.PiercedEardrums],
      subTreeConfig: { overridePlacement: [0, 1] },
    },
    {
      id: UpgradeType.PiercedEardrums,
      children: [],
      subTreeConfig: {},
      nodeConfig: { lengthMultiplier: 1.5 },
    },
    {
      id: UpgradeType.Encore,
      children: [UpgradeType.ObnoxiousGuitarist],
      subTreeConfig: {},
    },
    {
      id: UpgradeType.LockerRoomSpeech,
      children: [],
      subTreeConfig: {},
    },
  ],
  cleric: [
    {
      id: UpgradeType.RecruitWarriors,
      children: [
        UpgradeType.HeroResources,
        UpgradeType.RecruitWizards,
        UpgradeType.RecruitElves,
        UpgradeType.RecruitThieves,
        UpgradeType.RecruitBards,
        UpgradeType.BlessedAura,
        // UpgradeType.RecruitClerics,
      ],
      subTreeConfig: { overridePlacement: [0, 7, 1, 2, 6, 4, 3, 5], unlockAt: 1 },
    },
    {
      id: UpgradeType.HeroResources,
      children: [],
      subTreeConfig: {},
    },
    {
      id: UpgradeType.RecruitWizards,
      children: [],
      nodeConfig: { lengthMultiplier: 1.5 },
    },
    {
      id: UpgradeType.RecruitElves,
      children: [],
      nodeConfig: { lengthMultiplier: 1.5 },
    },
    {
      id: UpgradeType.RecruitThieves,
      children: [],
    },
    {
      id: UpgradeType.RecruitBards,
      children: [],
    },
    {
      id: UpgradeType.RecruitClerics,
      nodeConfig: { lengthMultiplier: 1.5 },
      children: [],
    },
    {
      id: UpgradeType.BlessedAura,
      children: [],
      nodeConfig: { lengthMultiplier: 1.5 },
      subTreeConfig: {},
    },
  ],
};
